import React, { useEffect, useState } from "react";
import "./styles/socialSecurity.css";
import { SocialSecurityCalculator } from "./components/SocialSecurityCalculator";
import { RetirementCalculator } from "./components/RetirementCalculator";
import { SocialSecurityModules } from "./components/SocialSecurityModules";
import { MODULE_API } from "../../apis";
import { calculateSocialSecurityResults } from "../../helpers/socialSecurityCalculations";
import { calculateTotalTax } from "../../helpers/taxCalculation";
import ModalVideo from "../ModuleVideos/ModalVideo";
export const SocialSecurityMain = () => {
  const [activeTab, setActiveTab] = useState("socialSecurity");
  const [loading, setIsLoading] = useState(false);
  const [socialFieldsData, setSocialFieldsData] = useState(null);
  const [socialResultData, setSocialResultData] = useState(null);

  // const result = calculateTotalTax(100000, "single", "California");

  // const resultWithCredit = calculateTotalTax(
  //   100000, // grossIncome
  //   "single", // filingStatus
  //   "California", // stateName
  //   {
  //     numChildrenUnder17: 2,
  //     contributionAmount: 2000,
  //     agi: 150000,
  //     improvementCost: 4000,
  //   }
  // );
  // console.log("resulllllll",result, resultWithCredit);

  return (
    <div className="social-security-main">
      <ModalVideo module="Social Security" autoOpen={true} />
      <div className="social-security-toggle-container">
        <div
          className={`social-security-toggle-button-container ${
            activeTab === "socialSecurity" ? "active" : ""
          }`}
        >
          <button
            className={`social-security-toggle-button ${
              activeTab === "socialSecurity" ? "active" : ""
            }`}
            onClick={() => setActiveTab("socialSecurity")}
          >
            Social Security Calculator
          </button>
        </div>
        <div
          className={`social-security-toggle-button-container ${
            activeTab === "retirementEarnings" ? "active" : ""
          }`}
        >
          <button
            className={`social-security-toggle-button ${
              activeTab === "retirementEarnings" ? "active" : ""
            }`}
            onClick={() => setActiveTab("retirementEarnings")}
          >
            Retirement Earnings Test Calculator
          </button>
        </div>
      </div>
      {activeTab === "socialSecurity" && (
        <SocialSecurityCalculator
          setSocialResultData={setSocialResultData}
          setSocialFieldsData={setSocialFieldsData}
        />
      )}
      {activeTab === "retirementEarnings" && <RetirementCalculator />}
      <SocialSecurityModules />
    </div>
  );
};
